// Module
var code = `<div class="number-pattern__wrapper">
  <label class="number-pattern__input-label">
   <input class="number-pattern__input"
          type="text"
          ng-model="\$ctrl.pattern"
          ng-disabled="\$ctrl.\$attrs.disabled"
          ng-change="\$ctrl.updateNgModel()"
    />
  </label>
  <div class="number-pattern__input-error"
       ng-if="\$ctrl.ngModel.\$error.parse">
    Pattern is invalid
  </div>
  <div class="number-pattern__input-error"
       ng-if="\$ctrl.ngModel.\$error.length">
    Pattern has invalid length ({{\$ctrl.length}} characters is required)
  </div>
  <ul class="number-pattern__manual">
    <li ng-repeat="option in \$ctrl.options"
      >
      <button ng-click="\$ctrl.addPattern(option)"
              ng-disabled="\$ctrl.\$attrs.disabled"
              class="number-pattern__item-button"
              type="button"
      >
        <div class="number-pattern__manual-icon">
          <i ng-class="option.iconClass"></i>
        </div>
        <div class="number-pattern__manual-details">
          <div class="number-pattern__manual-details-header">
            {{option.header}}
          </div>
          <div class="number-pattern__manual-details-text">
            {{option.text}}
          </div>
        </div>
      </button>
    </li>
  </ul>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/number-pattern/number-pattern.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;